import { canonical, newsArticleSchema } from "@utils";
import connectionsMixins from "~/plugins/mixins/nyt-connections";

export default {
	name: "NYTConnections",
	mixins: [connectionsMixins],
	head() {
		return {
			title: this.metaTitleMonthAndDay,
			link: [canonical(this.$route)],
			script: [
				newsArticleSchema({
					headline: this.metaTitleMonthAndDay,
					image: "https://wordfinder.yourdictionary.com/static/images/nyt-connections-og.jpg",
					datePublished: "2023-11-21T08:00:00.000Z",
					author: { type: "Person", name: "Carrie Grosvenor" },
				}),
			],
		};
	},
	computed: {
		isYesterdayPage() {
			return this.$store.getters["navigation/isYesterdayConnectionsPage"];
		},
		subtitle() {
			return this.isYesterdayPage
				? "Stumped on yesterday’s NYT Connections? We’re here to help with hints and answers!"
				: "Get help solving today's NYT Connections with our ultimate cheat tool, and never worry again.";
		},
		currentDateString() {
			return this.isYesterdayPage
				? this.humanFriendlyDate(this.todayPuzzle.date)
				: this.humanFriendlyDate("");
		},
	},
};
